/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Component, OnInit} from '@angular/core';
import {AbstractFormWrapper} from '../../../../models/battery/abstract-form-wrapper';

@Component({
  selector: 'app-edit-battery-pass',
  templateUrl: './edit-battery-pass.component.html',
  styleUrl: './edit-battery-pass.component.scss',
  standalone: false,
})
export class EditBatteryPassComponent
  extends AbstractFormWrapper
  implements OnInit {
  // Services are inherited from AbstractFormWrapper via field-level inject()
  // No need to override or re-inject them here
}
